import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

const Container = styled.div`
  display: flex;
  justify-content: end;
  padding: 20px 28px 20px 29.5px;
  border-top: 1px solid var(--line-gray);
`;

const StyledButton = styled(Button)`
  padding: 10px 43px 10px 44px;
`;

interface Props {
  onCancel: () => void;
}

const HistoryDataModalFooter = ({ onCancel }: Props) => {
  return (
    <Container>
      <StyledButton onClick={onCancel}>Close</StyledButton>
    </Container>
  );
};

export default HistoryDataModalFooter;
